export default "__VITE_ASSET__C$auE3rm__"